import { Monitor, Moon, Sun } from 'lucide-react';
import type { ThemeMode } from '@/shared/domain/types';
import { useT } from '@/shared/i18n/useT';
import { isThemeMode } from '@/shared/theme/themeContext';
import { useTheme } from '@/shared/theme/useTheme';
import { Icon } from '../icons/Icon';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '../ui/DropdownMenu';
import { IconButton } from '../ui/IconButton';

/** Selector de tema: claro, oscuro o según el sistema. El botón muestra el tema que se ve ahora. */
export function ThemeMenu() {
  const { t } = useT();
  const { mode, resolved, setMode } = useTheme();
  const options: Array<{ value: ThemeMode; label: string; icon: typeof Sun }> = [
    { value: 'light', label: t('aria.themeLight'), icon: Sun },
    { value: 'dark', label: t('aria.themeDark'), icon: Moon },
    { value: 'system', label: t('aria.themeSystem'), icon: Monitor },
  ];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <IconButton
          label={t('aria.theme')}
          icon={<Icon icon={resolved === 'dark' ? Moon : Sun} />}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuRadioGroup
          value={mode}
          onValueChange={(value) => isThemeMode(value) && setMode(value)}
        >
          {options.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              <Icon icon={option.icon} size={16} className="text-fg-muted" />
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
